module.exports = __webpack_public_path__ + "img/avatar-5.4e9ba324.jpg";